<template>
    <div style="padding-top: 10px">
      <div class="row" v-for="(comment, index) in comments" :key="index" style="margin-top: -5px">
        <div class="col-md-12">
          <comment :comment="comment"
                   :employee_name="getName(comment)"
                   :is-author="getIsAuthor(comment)"
                   :is-system="getIsSystem(comment)">
          </comment>
        </div>
      </div>
    </div>
</template>

<script>
    import Comment from "./comment";
    export default {
      name: "CommentList",
      components: {Comment},
      props: ["comments", "employees", "employee_id"],
      methods:{
        getName(comment){
          const employee = this.employees.filter(employee => parseInt(employee['employee_id']) === parseInt(comment['employee_id']));
          if (employee.length > 0){
            return employee[0]['first_name'] + " " + employee[0]['last_name'];
          }
          else{
            return "Employee Unknown"
          }
        },
        getIsAuthor(comment){
          return (parseInt(comment.employee_id) === parseInt(this.employee_id))
        },
        getIsSystem(comment){
          return (parseInt(comment.employee_id) === 0)
        },
      },
    }
</script>

<style scoped>

</style>
